<template>
    <div class="market">
        <img src="../../assets/bg222.png" class="headerImg" alt="" srcset="">
        <div class="radioBox">
            <div class="bgcalss">
                <div class="title_img radios">
                    <img src="../../assets/topic_a@2x.png" class="title_img_c" alt="" srcset="">
                </div>
            </div>
            <div class="content radioBox_content">
                <div>
                    <p class="title">1. 当地是否限制电摩<span class="red">*</span></p>
                    <van-radio-group v-model="qsCity.limitMotor" direction="horizontal">
                        <van-radio name="1">是
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                        <van-radio name="2">否
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                    <!-- <van-radio-group v-model="qsCity.limitMotor">
                        <van-cell-group>
                            <van-cell title="是" clickable @click="qsCity.limitMotor = '1'">
                                <template #right-icon>
                                    <van-radio name="1">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                            <van-cell title="否" clickable @click="qsCity.limitMotor = '2'">
                                <template #right-icon>
                                    <van-radio name="2">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group> -->
                </div>
                <div>
                    <p class="title">2. 当地是否需要上牌<span class="red">*</span></p>
                    <van-radio-group v-model="qsCity.mustRegister" direction="horizontal">
                        <van-radio name="1">是
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                        <van-radio name="2">否
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                    <!-- <van-radio-group v-model="qsCity.mustRegister">
                        <van-cell-group>
                            <van-cell title="是" clickable @click="qsCity.mustRegister = '1'">
                                <template #right-icon>
                                    <van-radio name="1">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                            <van-cell title="否" clickable @click="qsCity.mustRegister = '2'">
                                <template #right-icon>
                                    <van-radio name="2"><template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group> -->
                </div>
                <div>
                    <p class="title">3. 当地上牌审核是否严格<span class="red">*</span></p>
                    <van-radio-group v-model="qsCity.registerStrict" direction="horizontal">
                        <van-radio name="1">是
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                        <van-radio name="2">否
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                    <!-- <van-radio-group v-model="qsCity.registerStrict">
                        <van-cell-group>
                            <van-cell title="是" clickable @click="qsCity.registerStrict = '1'">
                                <template #right-icon>
                                    <van-radio name="1">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                            <van-cell title="否" clickable @click="qsCity.registerStrict = '2'">
                                <template #right-icon>
                                    <van-radio name="2">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group> -->
                </div>
            </div>
        </div>

        <div class="title_img">
            <img src="../../assets/topic_b@2x.png" class="title_img_c" alt="" srcset="">
        </div>
        <div class="content">

            <div>
                <p class="title">1. 当地集中购买人群<span class="red">*</span></p>
                <van-checkbox-group v-model="buyerGroup1" direction="horizontal">
                    <van-checkbox name="1">老年人
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="2">中年人
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="3">年轻人
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                </van-checkbox-group>
            </div>
            <div>
                <p class="title">2. 当地热销品类群 <span class="red">*</span></p>
                <van-checkbox-group v-model="popularCategory1" direction="horizontal">
                    <van-checkbox name="1">电摩
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="2">电自
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                </van-checkbox-group>
            </div>
            <div>
                <p class="title">3. 当地热销系列 <span class="red">*</span></p>
                <van-checkbox-group v-model="popularSeries1" direction="horizontal">
                    <van-checkbox name="1">鹰款
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="2">龟款
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="3">方正
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="4">经典
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-checkbox>
                </van-checkbox-group>
            </div>
        </div>
        <div class="title_img">
            <img src="../../assets/topic_c@2x.png" class="title_img_c" alt="" srcset="">
        </div>
        <div class="content">


            <p class="tips">注：简述题输入内容限制在200字以内</p>
            <div>
                <p class="title">1. 当地最大竞争对手<span class="red">*</span></p>
                <van-field v-model="qsCity.biggestCompetitor" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title">2. 当地最大竞争对手销量<span class="red">*</span></p>
                <van-field v-model="qsCity.competitorSales" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title">3. 最大竞争对手热销车型<span class="red">*</span></p>
                <van-field v-model="qsCity.competitorPopularSeries" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title">4. 用户对公司的建议（选填）<span class="red">*</span></p>
                <van-field v-model="qsCity.userCompanySuggestion" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title"> 5. 个人对终端门店的提案改善建议 <span class="red">*</span></p>
                <van-field v-model="qsCity.personalStoreSuggestion" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title">6. 个人对公司的提案改善建议<span class="red">*</span></p>
                <van-field v-model="qsCity.personalCompanySuggestion" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
            <div>
                <p class="title">7. 个人巡店心得<span class="red">*</span></p>
                <van-field v-model="qsCity.experience" class="inputs" rows="1" type="textarea" autosize
                    placeholder="请输入内容（必填）" />
            </div>
        </div>
        <div class="box_btn">
            <van-button type="primary" class="goback" @click="goback">上一步</van-button>
            <van-button type="primary" class="onNext" @click="onNext">提交</van-button>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { addInspect } from '../../apis/storeVisit'
export default {
    data() {
        return {
            text: '',
            list: ['老年人', '中年人', '年轻人'],
            result: [],
            radio1: '',
            radio2: '',
            radio3: '',
            activeIcon: require('../../assets/Select@2x.png'),
            inactiveIcon: require('../../assets/owner/unchecked.png'),
            "buyerGroup1": [],
            "popularCategory1": [],
            "popularSeries1": [],
            "qsCity": {
                "limitMotor": "",
                "mustRegister": "",
                "registerStrict": "",
                "buyerGroup": '',
                "popularCategory": '',
                "popularSeries": '',
                "biggestCompetitor": "",
                "competitorSales": "",
                "competitorPopularSeries": "",
                "userCompanySuggestion": "",
                "personalStoreSuggestion": "",
                "personalCompanySuggestion": "",
                "experience": ""
            }
        }
    },
    mounted () {
        window.scrollTo(0)
    },
    methods: {
        toggle(index) {
            // this.$refs.checkboxes[index].toggle();
        },
        goback() {
            this.$router.go(-1)
        },
        onNext() {
            console.log(this.qsCity)
            this.qsCity.buyerGroup = this.buyerGroup1.join(',');
            this.qsCity.popularCategory = this.popularCategory1.join(',');
            this.qsCity.popularSeries = this.popularSeries1.join(',');

            for (const key in this.qsCity) {
                if (this.qsCity.hasOwnProperty.call(this.qsCity, key)) {
                    const element = this.qsCity[key];
                    
                    if (!element) {
                        console.log(key, element)
                        Toast({
                            message: '请填写表单内容'
                        })
                        return
                    }

                }
            }
            this.qsCity.buyerGroup = this.buyerGroup1.join(',');
            this.qsCity.popularCategory = this.popularCategory1.join(',');
            this.qsCity.popularSeries = this.popularSeries1.join(',');
            this.$store.state.storeVisit.qsCity = this.qsCity;
            let data = this.$store.state.storeVisit;
            addInspect(data).then(res => {
                if (res.status === 0) {
                    this.keepRemoveCache();
                    this.$router.replace('/storevisit')
                } else {
                    Toast({
                        message: res.msg
                    })
                }

            })
        },
        //请输keep缓存
        keepRemoveCache() {
            let vnode = this.$vnode
            let parentVnode = vnode && vnode.parent;
            if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
                var key = vnode.key == null
                    ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
                    : vnode.key;
                var cache = parentVnode.componentInstance.cache;
                var keys = parentVnode.componentInstance.keys;
                console.log(cache, keys)
                keys.forEach(element => {
                    cache[element] = null
                });
                if (cache[key]) {
                    // remove key
                    if (keys.length) {
                        var index = keys.indexOf(key)
                        if (index > -1) {
                            keys.splice(index, 1)
                        }
                    }

                    cache[key] = null
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.market {
    background: linear-gradient(-26deg, #FFE2B8 0%, #FFFCF7 100%);
    height: 100%;

    .radioBox {
        margin-top: -120px;
        position: relative;
    }

    .radioBox_content {
        position: relative;
        z-index: 11;
    }

    .bgcalss {
        background: linear-gradient(0deg, rgba(255, 227, 187, 0) 0%, #FF5010 100%);
        border-radius: 6px;
        height: 75px;
        margin: 0 12px;
        position: relative;
        top: 60px;
    }

    .radios {
        z-index: 999;
        top: 8px !important;
    }

    .img-icon {
        height: 20px;
    }

    .title_img {
        text-align: center;
        position: relative;
        top: 20px;

        .title_img_c {
            width: 120px;
            height: 25px;
        }
    }

    .headerImg {
        width: 100%;
    }

    .header_tot {
        background: #D44F1B;
        height: 20px;
        margin: 0 20px;
        box-shadow: 1px 5px 5px #D44F1B;
    }

    .box_btn {
        display: flex;
        justify-content: space-around;
        padding: 30px 0;
    }

    .goback {
        background: #FFFFFF;
        border-radius: 24px;
        border: 0;
        color: #000;
        width: 40%;
    }

    .onNext {
        background: linear-gradient(0deg, #FF232D 0%, #FE6428 100%);
        box-shadow: 4px 9px 27px 0px rgba(255, 35, 45, 0.38);
        border-radius: 24px;
        border: 0;
        width: 40%;
    }

    .content {
        text-align: left;
        margin: 0 20px;
        background-color: #fff;
        padding: 12px;
        box-shadow: 6px 10px 7px 0px rgba(255, 225, 180, 0.56);

        .tips {
            font-size: 12px;
            font-weight: 400;
            color: #FF0000;
        }

        .red {
            color: #FF0000;
        }

        .title {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
        }

        .inputs {
            background: #F7F7F7;
            border-radius: 8px;
        }

        .uploadImg {
            display: flex;
            flex-wrap: wrap;

            .imgbox {
                position: relative;
                margin-right: 10px;
                width: 30%;
            }

            .carme {
                width: 100%;
                height: 100px;
            }

            .closeImg {
                position: absolute;
                font-size: 22px;

                font-weight: bold;
                right: -5px;
                top: 0;
                z-index: 999;
            }
        }
    }

}
</style>